import { createAuthClient } from "better-auth/react";
import { emailOTPClient } from "better-auth/client/plugins";
import { resolveApiBaseUrl } from "./api-url";

// Resolve via the same path as the Hono RPC client: localStorage
// override (set on the Login page when an installed desktop is pointed
// at the wrong URL) wins over VITE_API_URL. Otherwise Better Auth
// would keep talking to whatever URL was baked at build time even
// after the user overrode it, and login would silently fail with
// "Failed to fetch" on the wrong origin.
const baseURL = resolveApiBaseUrl();

// Better Auth React client — used by useAuth, the login page, and anywhere
// else we need to read the current session. baseURL is the API server, not
// the web app; cookies flow because the API responds with credentials-aware
// CORS headers.
export const authClient = createAuthClient({
  baseURL,
  plugins: [emailOTPClient()],
});

// Re-export the most-used handles so consumers don't have to know the
// authClient surface.
export const {
  signIn,
  signUp,
  signOut,
  useSession,
  getSession,
  emailOtp,
} = authClient;
